import LRUCache from 'lru-cache'

const options = {
  max: 500,
  maxAge: 24 * 60 * 60 * 1000
}

const cache = new LRUCache(options)

export default ({ app }, inject) => {
  inject('cache', cache)
}
